import { render, staticRenderFns } from "./BodyguardServicesFilters.vue?vue&type=template&id=4052df2a"
import script from "./BodyguardServicesFilters.vue?vue&type=script&lang=js"
export * from "./BodyguardServicesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports